const setinstances = instanceid => {
	//oracle Flex Instances
	switch (instanceid) {
		case 'VM.Standard3.Flex':
			return { maxOCPUS: 32, maxMEM: 512 };
		case 'VM.Standard.E3.Flex':
			return { maxOCPUS: 64, maxMEM: 1024 };
		case 'VM.Standard.E4.Flex':
			return { maxOCPUS: 64, maxMEM: 1024 };
		case 'VM.Optimized3.Flex':
			return { maxOCPUS: 18, maxMEM: 256 };
		case 'VM.Standard.A1.Flex':
			return { maxOCPUS: 80, maxMEM: 512 };
		default:
			return { maxOCPUS: null, maxMEM: null };
	}
};

export const ipValid = (ip) => {
	const v4 = new RegExp(/^(\d{1,3}\.){3}\d{1,3}$/);
	const v6 = new RegExp(/^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::$|^::1$/);

	return (v4.test(ip) || v6.test(ip));
};

export const setinstancesVol = (provider, selectedMarketStack) => {
	const marketplaceMin = { min: selectedMarketStack?.config?.min_volume, max: 2048 }
	const isMarketplace = selectedMarketStack && selectedMarketStack.config
	if (provider) {
		if (isMarketplace) {
			switch (provider) {
				case 'aws':
					return marketplaceMin;
				case 'oracle':
					return marketplaceMin;
				case 'azure':
					return marketplaceMin;
				case 'gcp':
					return marketplaceMin;
				case 'ibm':
					return marketplaceMin;
				default:
					throw new Error(`Invalid marketplace provider: ${provider}`);
			}
		}
		else {
			switch (provider) {
				case 'aws':
					return { min: 8, max: 2048 };
				case 'maas':
					return { min: 8, max: 2048 };
				case 'azure':
					return { min: 30, max: 2048 };
				case 'gcp':
					return { min: 20, max: 4096 };
				case 'oracle':
					return { min: 50, max: 10240 };
				case 'ibm':
					return { min: 100, max: 250 };
				default:
					return { min: null, max: null };
			}
		}
	}
};

export const validationInputUlt = (type, instanceid, currentvalue, ocpus, provider, selectedMarketStack) => {
	let instanceAttributes = setinstances(instanceid);
	let InstanceVolume = setinstancesVol(provider, selectedMarketStack);

	// Allow empty values - user may be in the middle of typing/clearing the field
	if (currentvalue === '' || currentvalue === null || currentvalue === undefined || !InstanceVolume) return true;

	let regEx = new RegExp(/[a-z,A-Z,!@#$%^&*()_+\-=[\]{};':"\\|/,.|~<>?\s]/g);
	if (type === 'PrivateIP') {
		regEx = new RegExp(/^(([12]?[0-9]{1,2}|2[0-4][0-9]|25[0-5])(\.|\/)){4}([1-2]?[0-9]|3[0-2])$/g);
		return regEx.test(currentvalue);
	}

	if (!regEx.test(currentvalue)) {
		if (type === 'ocpus')
			return (parseInt(currentvalue) > 0 && parseInt(currentvalue) <= instanceAttributes.maxOCPUS) || !currentvalue
				? true
				: false;
		else if (type === 'mem')
			return parseInt(currentvalue) >= parseInt(ocpus) &&
				parseInt(currentvalue) <= parseInt(ocpus) * 64 &&
				parseInt(currentvalue) <= instanceAttributes.maxMEM
				? true
				: false;
		else if (type === 'stackvolume')
			return parseInt(currentvalue) >= InstanceVolume.min && parseInt(currentvalue) <= InstanceVolume.max
				? true
				: false;
		else if (type === 'clusterservervolume')
			return parseInt(currentvalue) >= InstanceVolume.min && parseInt(currentvalue) <= InstanceVolume.max
				? true
				: false;
		else if (type === 'clusternodevolume')
			return parseInt(currentvalue) >= InstanceVolume.min && parseInt(currentvalue) <= InstanceVolume.max
				? true
				: false;
		else return true;
	} else return false;
};

export const validationMessUlt = (type, instanceid, ocpus, provider, selectedMarketStack) => {
	let instanceAttributes = setinstances(instanceid);
	let InstanceVolume = setinstancesVol(provider, instanceid);

	if (selectedMarketStack && selectedMarketStack.config) {
		InstanceVolume.min = selectedMarketStack.config.min_volume;
	}

	if (!instanceAttributes) return 'Instance ID not found';

	if (type === 'ocpuserror') return `Must be a number between 1 and ${instanceAttributes.maxOCPUS}`;
	else if (type === 'memerror')
		return parseInt(ocpus) * 64 <= instanceAttributes.maxMEM
			? `Must be a number between ${ocpus} and ${ocpus * 64} (Max ${instanceAttributes.maxMEM})`
			: `Must be a number between ${ocpus} and ${instanceAttributes.maxMEM} (Max ${instanceAttributes.maxMEM})`;
	else if (type === 'stackvolume') return `Must be a number between ${InstanceVolume.min} and ${InstanceVolume.max} `;

	else if (type === 'clusterservervolume')
		return `Must be a number between ${InstanceVolume.min} and ${InstanceVolume.max} `;
	else if (type === 'clusternodevolume')
		return `Must be a number between ${InstanceVolume.min} and ${InstanceVolume.max} `;
	else if (type === 'PrivateIP') return `Must be an IPv4 with Subnet Mask. Example: 172.16.0.0/16 `;
	else return 'not identified';
};

export const validateClusterName = (name) => {
	if (typeof name !== 'string') return { isValidName: false, Error: 'Name must be a string.' }
	if (name.length >= 15) return { isValidName: false, Error: 'Name cannot exceed 15 characters.' }
	if (/[^a-z0-9-]/g.test(name)) return { isValidName: false, Error: 'Invalid characters in the name. Use only lowercase letters, numbers, and hyphens.' }
	if (/^-|-$|--/g.test(name)) return { isValidName: false, Error: 'Hyphens cannot start or end the name, and consecutive hyphens are not allowed.' }
	if (/^\d/.test(name)) return { isValidName: false, Error: 'Name cannot start with a number.' }
	return { isValidName: true }
}
